<template>
  <div>
    <h1>Carga Masiva de Procesos</h1>
<div :class="typeAler" v-if="viewAlert" role="alert">
  {{message}}
</div>
    <div>
      <label for="">Seleccione un usuario</label>
      <multiselect v-model="user" :options="UsersFromController" :multiple="false" :close-on-select="true" :clear-on-select="false" label="name" placeholder="Seleccionar Usuario" selectLabel="Presione para seleccionar" selectedLabel="Seleccionada" deselectLabel="Presione para eliminar" track-by="name">    
      </multiselect>      
      </div>
      <div>
        <vue-dropzone ref="myVueDropzoneFiles" @vdropzone-complete="showAlert"  id="dropzone" v-bind:options="dropzoneOptionsMassive" v-if="dropzoneOptionsMassive.url != ''"/>
      </div>
    </div>
  </div>
</template>

<script>
import AutoComplete from './../../../own/autocomplete-local'
const Multiselect =() => import('vue-multiselect')
import vue2dropzone from 'vue2-dropzone'
export default {
  name:'FormMassive',
  props:['client','users'],
  data(){
    return{
      client_user_id:null,
      user:{},
      typeAler: '',
      message:'',
      viewAlert:false,
      dropzoneOptionsMassive: {
        url: '',
        thumbnailWidth: 150,
        maxFilesize: 10,
        headers: {
          token:''
        },
        dictDefaultMessage: 'Arrastrar y soltar'
      }
    }
  },
  computed:{
    clientFromController:{
      get(){
        return this.client
      }
    },
    UsersFromController:{
      get(){
        return this.users
      }
    }
  },
  components:{
    AutoComplete,
    'vue-dropzone':vue2dropzone,
    'multiselect':Multiselect
  },
  created(){
    this.UsersFromController.forEach(user => {
      if(user.last_name.split('')[user.last_name.split('').length - 1] == " "){
        let last_name = user.last_name.split('')
        last_name.pop()
        user.name = user.first_name  + last_name.join('')
      }else{
        user.name = user.first_name  + user.last_name
      }
    });

    this.defaultHeaders()
  },
  watch:{
    client_user_id(val){
      this.dropzoneOptionsMassive.url = '/api/v1/projects/import?current_user='+val+"&created_at_front=" + new Date().toLocaleString()
      console.log(this.dropzoneOptionsMassive.url)
    },
    user(val){
      this.client_user_id = val.id
    }
  },
  methods:{
    defaultHeaders(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      this.dropzoneOptionsMassive.headers['x-csrf-token'] = token
      this.dropzoneOptionsMassive.headers.token = token
			//this.UsersFromController.headers['Accept'] = 'application/json';
			//axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    showAlert(response){
      if(response.status = "success"){
        this.typeAler = 'alert alert-success'
        this.message = 'Procesos creados correctamente'
      }else{
        this.typeAler = 'alert alert-danger'
        this.message = 'Hubo un error :(, revisa el archivo e intenta nuevamente '
      }
      this.viewAlert = true
      console.log(response)
    }
  }
}
</script>

<style>

</style>